import React from "react";
import { inputCls } from "@/components/common";

export const CONTACT_METHODS: [string, string][] = [["email", "Email"], ["phone", "Phone call"], ["text", "Text message"], ["whatsapp", "WhatsApp"]];
export const contactLabel = (k?: string) => CONTACT_METHODS.find(([m]) => m === k)?.[1] || "";
export const needsPhone = (f: any) => f.kind === "phone" || (f.surprise && ["phone", "text", "whatsapp"].includes(f.contact_method));

export function SurpriseContact({ f, setF }: { f: any; setF: (v: any) => void }) {
  return (
    <div className="border-t border-neutral-200 pt-5 space-y-4" data-testid="surprise-contact">
      <p className="eyebrow">Best way to reach you</p>
      <div className="flex flex-wrap gap-2" role="radiogroup" aria-label="Best way to reach you">
        {CONTACT_METHODS.map(([k, l]) => (
          <label key={k} className="cursor-pointer" data-testid={`surprise-contact-${k}`}>
            <input type="radio" name="contact_method" value={k} checked={f.contact_method === k} onChange={() => setF({ ...f, contact_method: k })} className="sr-only peer" />
            <span className="inline-block px-4 py-2.5 text-[11px] tracking-[0.14em] uppercase border border-neutral-300 transition-colors hover:border-neutral-600 peer-checked:bg-[var(--c-fg)] peer-checked:text-[var(--c-bg)] peer-checked:border-[var(--c-fg)] peer-focus-visible:ring-2 peer-focus-visible:ring-[var(--c-primary)]">{l}</span>
          </label>
        ))}
      </div>
      <input value={f.contact_note} maxLength={300} onChange={(e) => setF({ ...f, contact_note: e.target.value })}
        placeholder="When to contact you, and anything to avoid (optional) — e.g. weekdays after 5pm, no voicemails"
        className={inputCls} data-testid="surprise-contact-note" />
    </div>
  );
}
